import { jsx as _jsx } from "react/jsx-runtime";
import { Filter } from '@awaze/design-system.components.filter';
import styled from 'styled-components';
import { v4 as uuid } from 'uuid';
const StyledFilterList = styled.ul `
  margin: 0;
  padding: 0;
  list-style: none;
`;
/**
 * The filter-list component is a wrapper that displays a list of Filter components based on the supplied props.
 *
 * Its current use is within the filters panel on the results page.
 */
export const FilterList = ({ filterGroup, filters, selectedFilters, onFilterClick, ...rest }) => {
    return (_jsx(StyledFilterList, { ...rest, children: filters.map((filter) => (_jsx(Filter, { groupId: filterGroup, featureId: filter.featureId, featureName: filter.featureName, count: filter.count, checked: selectedFilters.includes(filter.featureId), value: filter.featureId, onFilterClick: onFilterClick, ariaLabel: filter.ariaLabel }, `${filterGroup}-${filter.featureId}-${uuid()}`))) }));
};
//# sourceMappingURL=filter-list.js.map